/*eslint-disable*/
import { configureStore } from '@reduxjs/toolkit'
import errorReducer from './reducers/errorSlice'
import userProfileReducer from './reducers/userProfile'
import groupsReducer from './reducers/groupsSlice'
import usersReducer from './reducers/usersSlice'
import uploadRequestsReducer from './reducers/uploadRequestsSlice'
import uploadStatusReducer from './reducers/uploadStatusSlice'
import userActivitiesReducer from './reducers/userActivitiesSlice'
import healthCheckReducer from './reducers/healthCheckSlice'
import userBannerReducer from './reducers/userBannerSlice'
import bulkHealthCheckSlice from './reducers/bulkHealthCheckSlice'
import surveyTemplateSlice from './reducers/surveyTemplateSlice'
import surveyReducer from './reducers/surveySlice'
import supportReducer from './reducers/supportSlice'
import campaignReviewReducer from './reducers/reviewSlice'

const store = configureStore({
  reducer: {
    error: errorReducer,
    userProfile: userProfileReducer,
    groups: groupsReducer,
    users: usersReducer,
    uploadRequests: uploadRequestsReducer,
    uploadStatus: uploadStatusReducer,
    userActivities: userActivitiesReducer,
    healthCheck: healthCheckReducer,
    userBanner: userBannerReducer,
    bulkHealthCheck: bulkHealthCheckSlice,
    surveyTemplates: surveyTemplateSlice,
    survey: surveyReducer,
    support: supportReducer,
    reviews: campaignReviewReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export default store
